<template lang="pug">
	.asset-video-info(v-if="showed && video" v-window)
		.card
			.card-header
				i.fa.fa-film
				span Video Info
			.card-body.collapse.show
				.form-line
					.video
						video(:src="video.path" controls autoplay loop muted playsinline)
				.form-actions
					button.btn.btn-outline-primary.download-button(type="button" @click="downloadVideo(video)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Download video'}")
						i.fa.fa-download
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	export default {
		name: "AssetVideoInfo",
		mixins: [Screen],
		screen: {
			updateOn: [

			],
			events: {
				"Show AssetVideoInfo": function(creative, asset, variation, video) {

					this.creative = creative;
					this.asset = asset;
					this.variation = variation;
					this.video = video;

					this.update();

				}
			}
		},
		data() {

			this.creative = null;
			this.asset = null;
			this.variation = null;
			this.video = null;

			return {

			}

		},
		methods: {
			collectData() {

			},
			async downloadVideo(video) {

				// 1. Получаем файл видео
				const response = await fetch(video.path);
				const blob = await response.blob();

				// 2. Создаём временный object URL из blob
				const blobURL = URL.createObjectURL(blob);

				// 3. Создаём скрытый <a> и программно кликаем по нему
				const link = document.createElement('a');
				link.href = blobURL;
				link.download = video.fileName; // Имя, которое увидит пользователь
				document.body.appendChild(link);
				link.click();

				// 4. Очистка
				document.body.removeChild(link);
				URL.revokeObjectURL(blobURL);

			}
		}
	}
</script>


<style lang="sass">

	.asset-video-info
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			button
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.download-button

				i
					margin-right: 0

			.btn-ghost-dark, .btn-dark
				color: #fff

			.card-header
				display: flex
				flex-direction: row

		.form-line
			display: flex
			flex-direction: row
			justify-content: center
			align-items: center

		.video
			position: relative
			width: 100%
			display: flex
			justify-content: center

			video
				max-width: 100%
				max-height: 70vh
				border: 2px solid var(--gray-dark)
				background-color: #000

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px

			.right-button
				margin-left: auto

</style>
